app.controller("CreateAgreementController", ["$scope", "StaticData", "$stateParams", "$filter", "$uibModal", "ConfirmModal", "AuthService", "ProgramService", "Students", "Lecturer", "Users", "$state", "AgreementService", "toastr", "usSpinnerService",
    function ($scope, StaticData, $stateParams, $filter, $uibModal, ConfirmModal, AuthService, ProgramService, Students, Lecturer, Users, $state, AgreementService, toastr, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.title = null;
        $scope.actionButtonText = null;
        $scope.foo = null;
        $scope.receiver = "student";
        $scope.program = null;
        $scope.level = null;
        $scope.state = null;
        $scope.faculty = null;
        $scope.gender = null;
        $scope.activeState = null;
        $scope.semester = 'სემესტრი';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.panelTitle = 'შეთანხმების შექნა';
        $scope.buttonText = 'გაგზავნა';
        $scope.operationType = 'send';
        $scope.users = [];

        $scope.getUsers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Users.list({query: query}).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.$watch('user', function (val) {
            if (val && val._id) {
                $scope.users.push(val);
                $scope.user = null;
                $scope.totalItems = $scope.users.length;
            }
        }, true);

        $scope.delete_user = function (id) {
            var el_index = _.findIndex($scope.users, function (user) {
                return id === user._id;
            });

            $scope.users.splice(el_index, 1);
            $scope.totalItems = $scope.users.length;
        };

        if ($stateParams.operationType) $scope.operationType = $stateParams.operationType;
        if ($scope.operationType === 'edit') {
            $scope.panelTitle = 'შეთანხმების რედაქტირება';
            $scope.buttonText = 'რედაქტირება';
        } else if ($scope.operationType === 'resend') {
            $scope.panelTitle = 'შეთანხმების გადაგზავნა';
            $scope.buttonText = 'გადაგზავნა';
        }

        if ($stateParams.agreementId) {
            AgreementService.getById({
                agreementId: $stateParams.agreementId
            }).then(function (agreement) {
                $scope.title = agreement.title;
                $scope.actionButtonText = agreement.actionButtonText;
                $scope.foo = agreement.text;
                $scope.activeState = agreement.onlyActiveLectures;
                $scope.receiver = agreement.filter.type;
                if (agreement.filter.type === "student") {
                    $scope.faculty = agreement.filter.faculty;
                    $scope.level = agreement.filter.level;
                    $scope.program = agreement.filter.program;
                    $scope.state = agreement.filter.state;
                    $scope.semester = agreement.filter.semester;
                    $scope.gender = agreement.filter.gender;
                }
            })
        }

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = [{name: "სტატუსი"}].concat(states);
        });

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.changeReceiver = function (newType) {
            if(newType === 'lecturer') {
                StaticData.getItemsByKey("lecturer_states").then(function (activeStates) {
                    $scope.activeStates = [{name: "მდგომარეობა"}].concat(activeStates);
                });
                $scope.activeStates = null;
                $scope.getLecturers();
            }
            if(newType === 'student') {
                $scope.getStudents();
            } else {
                $scope.state = null;
                $scope.faculty = null;
                $scope.program = null;
                $scope.level = null;
                $scope.gender = null;
                $scope.semester = 'სემესტრი';
            }
            $scope.totalItems = 0;
            $scope.receiver = newType;
        };

        $scope.getStudents = function () {
            usSpinnerService.spin("root");
            Students.list({
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                state: $scope.state,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined,
                program: $scope.program ? $scope.program._id : undefined,
                gender: $scope.gender
            }).then(function (data) {
                if ($scope.receiver === 'student') $scope.totalItems = data.total;
                usSpinnerService.stop("root");
            });
        };

        $scope.getLecturers = function () {
            Lecturer.list({
                activeState: $scope.activeState
            }).then(function (data) {
                $scope.totalItems = data.total
            });
        };

        $scope.$watch('program', function (val) {
            if (val && val._id) {
                $scope.getStudents()
            }
        }, true);

        $scope.show = function () {
            var agreement = {
                text: $scope.foo,
                title: $scope.title,
                actionButtonText: $scope.actionButtonText,
                createDateString: $filter('date')(new Date(), 'HH:mm dd-MM-yyyy')
            };

            $uibModal.open({
                controller: "AgreementsWindowController",
                templateUrl: _pb + 'agreements/agreement-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {agreement: agreement};
                    }
                }
            }).result
                .then(function (result) {

                }, function () {

                });
        };

        $scope.send = function () {
            var agreement = {
                _id: $stateParams.agreementId || undefined,
                update: $scope.operationType === 'edit',
                text: $scope.foo,
                title: $scope.title,
                actionButtonText: $scope.actionButtonText,
                receiversList: [],
                filter: {
                    type: $scope.receiver,
                    state: $scope.state,
                    faculty: $scope.faculty,
                    program: $scope.program ? $scope.program._id : null,
                    level: $scope.level,
                    semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined,
                    gender: $scope.gender
                }
            };

            if ($scope.receiver === 'users') {
                agreement.receiversList = $scope.users;
                agreement.receiversList = $scope.users.map(user => {
                    return user._id;
                })
            }

            if ($scope.receiver === 'lecturer') {
                agreement.onlyActiveLectures = $scope.activeState;
            }

            if (!$scope.title) toastr.error('', 'გთხოვთ ჩაწეროთ სათაური');
            else if (!$scope.foo) toastr.error('', 'გთხოვთ ჩაწეროთ ტექსტი');
            else if (!$scope.actionButtonText) toastr.error('', 'გთხოვთ ჩაწეროთ ქმედების სახელი');
            else {

                if ($scope.operationType === 'send') {

                    AgreementService.send(agreement).then(function () {
                        toastr.success('', 'შეთანხმება გაგზავნილია');
                        $state.go('admin.agreement.send')
                    }).catch(function () {
                        toastr.error('', 'შეთანხმების გაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType === 'resend') {
                    AgreementService.send(agreement).then(function () {
                        toastr.success('', 'შეთანხმება გადაგზავნილია');
                        $state.go('admin.agreement.send')
                    }).catch(function () {
                        toastr.error('', 'შეთანხმების გადაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType === 'edit') {
                    ConfirmModal.show({
                        title: "ყურადღება",
                        message: "შეთანხმება პირვანდელი სახით წაიშლება და შეინახება მხოლოდ რედაქტირებული"
                    }).result.then(function () {
                        AgreementService.send(agreement).then(function () {
                            toastr.success('', 'შეთანხმება რედაქტირებულია');
                            $state.go('admin.agreement.send')
                        }).catch(function () {
                            toastr.error('', 'შეთანხმების რედაქტირებისას დაფიქსირდა შეცდომა');
                        })
                    });
                }
            }
        };
    }
]);
